import { LoadingButton } from "@mui/lab";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";
import { IconUserPlus } from "@tabler/icons-react";
import { isEmpty } from "lodash";
import { useState } from "react";
import Functions from "../../../../callable/functions";
import felixAnalytics from "../../../../felixAnalytics";
import Business from "../../../../models/business";
import { Perfil } from "../../../../models/enum";
import { useSnackBar } from "../../../../stores/snackBarStores";
import FelixAvatar from "../../../util/ui/felixAvatar";

type Props = {
  business: Business;
  open: boolean;
  onClose: (success: boolean) => void;
};

export default function CriarUsuario({ open, onClose }: Props) {
  const [nome, setNome] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [enviandoConvite, setEnviandoConvite] = useState(false);
  const snackBar = useSnackBar();

  const enviarConvite = async () => {
    setEnviandoConvite(true);
    felixAnalytics.track("convite-usuario-enviar");
    await new Functions()
      .enviarConviteUsuario({
        nome,
        email,
      })
      .then(() => {
        snackBar({
          type: "ALERT",
          payload: {
            mensagem: `O colaborador ${nome} foi criado.`,
            severidade: "success",
          },
        });
      })
      .catch((error) => {
        snackBar({
          type: "ALERT",
          payload: {
            mensagem:
              error.details.code === "auth/email-already-exists"
                ? `Esse e-mail já está cadastrado na Felix.`
                : `Houve um erro ao enviar o convite para o colaborador. Por favor, tente novamente ou entre em contato com nosso suporte.`,
            severidade: "error",
          },
        });
        console.error(error);
      })
      .finally(() => setEnviandoConvite(false))
      .finally(() => onClose(true));
  };

  return (
    <Dialog open={open} maxWidth="xs" fullWidth>
      <DialogTitle color="text.primary">
        <Box display="flex" flexDirection="row" alignItems="center">
          <Box mr={1}>
            <IconUserPlus size={16} />
          </Box>
          <Typography variant="h4">
            Adicionar colaborador
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Box display="flex" flexDirection="column" alignItems="center">
          <FelixAvatar nome={nome} size={64} perfil={Perfil.CONTADOR} />
          <TextField
            sx={{ my: 2 }}
            size="small"
            margin="none"
            fullWidth
            id="nome"
            label="Nome"
            name="nome"
            autoComplete="nome"
            value={nome}
            onChange={(e) => setNome(e.target.value)}
          />
          <TextField
            sx={{ my: 2 }}
            size="small"
            margin="none"
            fullWidth
            id="email"
            label="Email"
            name="email"
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose(false)} color="inherit">
          Cancelar
        </Button>
        <LoadingButton
          variant="contained"
          size="small"
          color="primary"
          disabled={isEmpty(nome) || isEmpty(email)}
          loading={enviandoConvite}
          onClick={enviarConvite}
        >
          Adicionar
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
